import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Arrow } from '../../images/arrow-right.svg'
import { ReactComponent as Aicon } from '../../images/a-icon.svg'
import { ReactComponent as BubbleTip } from '../../images/bubbletip.svg'
import { ReactComponent as BubbleTipHorizontal } from '../../images/bubbletip-horizontal.svg'

const CtaItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  user-select: none;
  padding-left: 10rem;
  gap: 0.5rem;

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    flex-direction: column;
    height: auto;
    padding-left: 0;
  }

  transition: transform 0.1s;

  :hover {
    transform: scale(1.02);
    cursor: pointer;
  }
`

const CtaItemText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: flex-start;
  flex: 1;
  background-color: #000450;
  color: white;
  padding: 1.5rem 1rem;
`

const CtaItemCta = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  padding: 1em;

  &,
  :hover,
  :active,
  :visited {
    color: rgb(0, 4, 80);
  }
`

const ResponsiveBubbleTipContainer = styled.div`
  display: flex;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm.min}) {
    flex-direction: column;
    flex: 0 0 1em;
    height: 100%;
    justify-content: center;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    flex-direction: row;
    justify-content: flex-end;
    flex: 0 0 1.5em;
    width: 100%;
    padding-right: 1.5rem;
  }
`

const ResponsiveBubbleTip = styled(BubbleTip)`
  fill: #ff6063;

  & path {
    opacity: 1;
  }

  transform: rotate(180deg);

  @media screen and (min-width: ${props => props.theme.breakpoints.sm.min}) {
    width: 1em;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    display: none;
  }
`
const ResponsiveBubbleTipHorizontal = styled(BubbleTipHorizontal)`
  fill: #ff6063;

  & path {
    opacity: 1;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm.min}) {
    display: none;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    margin-left: 1em;
    height: 1.5em;
  }
`

const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    flex-direction: row;
    justify-content: flex-end;
    padding-right: 2rem;
  }
`

const SummaryIconContainer = styled.div`
  background-color: rgb(0, 4, 80);
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const CtaItemBubbleContainer = styled.div`
  background-color: #ff6063;
  border-radius: 1.5rem;
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    flex-direction: column;
    height: auto;
  }
`

const BubbleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm.min}) {
    max-width: ${props => props.theme.breakpoints.md.max};
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xs.max}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const CtaItemBubble = ({ children }) => {
  return (
    <BubbleWrapper>
      <CtaItemBubbleContainer>{children}</CtaItemBubbleContainer>
      <ResponsiveBubbleTipContainer>
        <ResponsiveBubbleTip />
        <ResponsiveBubbleTipHorizontal />
      </ResponsiveBubbleTipContainer>
    </BubbleWrapper>
  )
}

const CtaItemSummary = () => {
  return (
    <SummaryContainer>
      <SummaryIconContainer>
        <Aicon />
      </SummaryIconContainer>
    </SummaryContainer>
  )
}

const CtaItem = ({ text }) => {
  return (
    <CtaItemContainer>
      <CtaItemBubble>
        <CtaItemText>{text}</CtaItemText>
        <CtaItemCta>
          Jutellaan lisää
          <Arrow />
        </CtaItemCta>
      </CtaItemBubble>
      <CtaItemSummary />
    </CtaItemContainer>
  )
}
export default CtaItem
